import React from 'react'

export const StateLabel = ({ state }: { state?: string }) => {
  if (!state) return null
  if (state === 'activated') return null
  return <span className={`badge badge-${state}`}>{i18n.t(`misc.state_labels.${state}`)}</span>
}
